export default {
  methods: {
    jumpDetail(item) {
      let { contentType, url, contentId, page, otherInfo } = item
      if (otherInfo) otherInfo = JSON.parse(otherInfo)
      contentType = contentType || otherInfo.contentType
      url = url || otherInfo.url
      contentId = contentId || page
      if (contentType == 1) {
        //外链
        window.location.href = url
      } else if (contentType == 5) {
        //富文本
        const opts = {
          url
        }
        this.bus.$emit('showFileDown', opts)
      } else {
        this.$router.push({
          name: 'mobile_detail',
          query: {
            id: contentId
          }
        })
      }
    }
  }
}
